import React, { useEffect, useState } from "react";
import SocialLinkIcon from "./SocialLinkIcon";
import SocialLinkInputModal from "./SocialLinkInputModal";

const socialPlatforms = [
  { name: "Instagram", icon: <SocialLinkIcon platform="instagram" />, placeholder: "https://instagram.com/username" },
  { name: "x", icon: <SocialLinkIcon platform="x" />, placeholder: "https://x.com/username" },
  { name: "TikTok", icon: <SocialLinkIcon platform="tiktok" />, placeholder: "https://tiktok.com/@username" },
  { name: "Threads", icon: <SocialLinkIcon platform="threads" />, placeholder: "https://threads.net/@username" },
  { name: "LinkedIn", icon: <SocialLinkIcon platform="linkedin" />, placeholder: "https://linkedin.com/in/username" },
  { name: "YouTube", icon: <SocialLinkIcon platform="youtube" />, placeholder: "https://youtube.com/@channel" },
  { name: "substack", icon: <SocialLinkIcon platform="substack" />, placeholder: "https://username.substack.com" },
  { name: "Website", icon: <SocialLinkIcon platform="website" />, placeholder: "https://yourwebsite.com" },
];

export default function SocialLinksInput(props) {
 
  const { onChange, links } = props;

  const [theLinks, setLinks] = useState(links);

  const [showSocialLinksInput, setShowSocialLinksInput] = useState(false);
  
  const [platform, setPlatform] = useState("");
  const [url, setUrl] = useState("");
  const [placeholder, setPlaceholder] = useState("");

  useEffect(() => {
    setLinks(links);
  }, [links]);

  const handleChange = (platform, value) => {
    let updated = [...theLinks, { platform, url: value }];
    setLinks(updated);
    onChange?.(updated);
  };

  const handleShowAddInput = (platform, placeholder) => {
    setPlatform(platform);
    setPlaceholder(placeholder);
    setShowSocialLinksInput(true);
  }

  return (
    <div className="social-links-input" style={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
      {showSocialLinksInput && <SocialLinkInputModal show={showSocialLinksInput} dismiss={() => setShowSocialLinksInput(false)} platform={platform} url={url} onChange={handleChange} placeholder={placeholder} />}
      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center", gap: "0.5rem", maxWidth: "400px" }}>
        {socialPlatforms.map(({ name, icon, placeholder }) => (
          <div onClick={() => handleShowAddInput(name, placeholder)} key={name} style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            {icon}
          </div>
        ))}
      </div>
    </div>
  );
}